export default "__VITE_PUBLIC_ASSET__7fbe38e5__"